<template>
  <b-modal
    :id="id"
    ref="modal"
    hide-header
    hide-footer
    body-class="p-0 overflow-hidden"
    content-class="border-0 shadow-lg"
    dialog-class="modal-xl-custom"
    size="xl"
    @shown="onShown"
  >
    <div
      class="modal-header-premium p-3 d-flex align-items-center"
      style="background: linear-gradient(135deg, #0f766e 0%, #155e75 100%) !important;"
    >
      <div class="header-icon-wrapper mr-3 bg-white-10">
        <i class="fa fa-line-chart text-white"></i>
      </div>
      <div>
        <h5 class="mb-0 font-weight-bold text-white">Dashboard Operacional de Vendas</h5>
        <small class="text-white-50">Operacao por DT_PEDIDO com visao estimada, efetiva e consolidada</small>
      </div>
      <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="fechar">
        <i class="fa fa-times fa-lg"></i>
      </b-button>
    </div>

    <div class="report-container bg-soft-gray overflow-auto" style="max-height: 85vh;">
      <div class="modal-info-bar m-3 mb-0 bg-light border shadow-sm p-3 rounded">
        <b-row align-v="center">
          <b-col md="4" class="mb-3 mb-md-0">
            <small class="modal-label-premium">Janela Operacional</small>
            <h5 class="mb-0 font-weight-bold text-dark">{{ formatDataBR(filtros.dt1) }} ate {{ formatDataBR(filtros.dt2) }}</h5>
          </b-col>
          <b-col md="4" class="mb-3 mb-md-0 border-left-md">
            <small class="modal-label-premium">Base Principal</small>
            <h5 class="mb-0 font-weight-bold text-primary">Pedidos por Data do Pedido</h5>
            <small class="text-muted font-weight-bold">Finalizados tambem entram se nasceram no periodo</small>
          </b-col>
          <b-col md="4" class="text-md-right">
            <small class="modal-label-premium">Leitura Gerencial</small>
            <h5 class="mb-0 font-weight-bold text-success">Volumes, Quantidade e Lucro</h5>
          </b-col>
        </b-row>
      </div>

      <div class="p-3 pb-0">
        <div class="modal-section-title mb-3">
          <i class="fa fa-filter mr-2 text-primary"></i> Filtros do Periodo
        </div>
        <b-row>
          <b-col md="4" class="mb-3">
            <b-form-group label="Data inicial">
              <cec-input-data v-model="filtros.dt1" />
            </b-form-group>
          </b-col>
          <b-col md="4" class="mb-3">
            <b-form-group label="Data final">
              <cec-input-data v-model="filtros.dt2" />
            </b-form-group>
          </b-col>
          <b-col md="4" class="mb-3 d-flex align-items-end">
            <b-button variant="success" pill class="px-4 font-weight-bold shadow-sm w-100" @click="carregarDados" :disabled="loading">
              <i class="fa fa-refresh mr-1"></i> ATUALIZAR PAINEL
            </b-button>
          </b-col>
        </b-row>
      </div>

      <b-overlay :show="loading" rounded="sm" opacity="0.6">
        <div class="p-3 pt-0">
          <b-row>
            <b-col md="6" lg="4" xl="3" class="mb-3">
              <div class="kpi-card-premium border-left-warning h-100 mb-0">
                <small>Volumes Estimados</small>
                <h4 class="mb-0 text-warning">{{ formatNumero(resumo.pecasEstimadas) }}</h4>
              </div>
            </b-col>
            <b-col md="6" lg="4" xl="3" class="mb-3">
              <div class="kpi-card-premium border-left-info h-100 mb-0">
                <small>Volumes Efetivos</small>
                <h4 class="mb-0 text-info">{{ formatNumero(resumo.pecasEfetivas) }}</h4>
              </div>
            </b-col>
            <b-col md="6" lg="4" xl="3" class="mb-3">
              <div class="kpi-card-premium border-left-primary h-100 mb-0">
                <small>Quantidade Estimada</small>
                <h4 class="mb-0 text-primary">{{ formatPeso(resumo.quantEstimada) }}</h4>
              </div>
            </b-col>
            <b-col md="6" lg="4" xl="3" class="mb-3">
              <div class="kpi-card-premium border-left-success h-100 mb-0">
                <small>Quantidade Efetiva</small>
                <h4 class="mb-0 text-success">{{ formatPeso(resumo.quantEfetiva) }}</h4>
              </div>
            </b-col>
            <b-col md="6" lg="4" xl="3" class="mb-3">
              <div class="kpi-card-premium border-left-dark h-100 mb-0">
                <small>Consolidado</small>
                <h4 class="mb-0 text-dark">{{ formatPeso(resumo.quantConsolidada) }}</h4>
              </div>
            </b-col>
            <b-col md="6" lg="4" xl="3" class="mb-3">
              <div class="kpi-card-premium border-left-primary h-100 mb-0">
                <small>Total Consolidado</small>
                <h4 class="mb-0 text-primary">{{ formatBRL(resumo.receitaConsolidada) }}</h4>
              </div>
            </b-col>
            <b-col md="6" lg="4" xl="3" class="mb-3">
              <div class="kpi-card-premium border-left-teal h-100 mb-0">
                <small>Lucro Consolidado</small>
                <h4 class="mb-0 text-teal">{{ formatBRL(resumo.lucroConsolidado) }}</h4>
              </div>
            </b-col>
            <b-col md="6" lg="4" xl="3" class="mb-3">
              <div class="kpi-card-premium border-left-success h-100 mb-0">
                <small>% Lucro Consolidado</small>
                <h4 class="mb-0 text-success">{{ formatPercentual(resumo.percentualLucro) }}</h4>
              </div>
            </b-col>
          </b-row>

          <b-row>
            <b-col lg="6">
              <b-card class="border-0 shadow-sm mb-4">
                <template #header>
                  <div class="d-flex align-items-center">
                    <i class="fa fa-cubes mr-2 text-primary"></i>
                    <span class="font-weight-bold">Produtos com Maior Quantidade Consolidada</span>
                  </div>
                </template>
                <div style="height: 300px;">
                  <canvas ref="chartProdutosQuantidade"></canvas>
                </div>
              </b-card>
            </b-col>
            <b-col lg="6">
              <b-card class="border-0 shadow-sm mb-4">
                <template #header>
                  <div class="d-flex align-items-center">
                    <i class="fa fa-money mr-2 text-success"></i>
                    <span class="font-weight-bold">Produtos com Maior % de Lucro</span>
                  </div>
                </template>
                <div style="height: 300px;">
                  <canvas ref="chartProdutosLucro"></canvas>
                </div>
              </b-card>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="12">
              <b-card class="border-0 shadow-sm mb-4">
                <template #header>
                  <div class="d-flex align-items-center">
                    <i class="fa fa-calendar mr-2 text-info"></i>
                    <span class="font-weight-bold">Evolucao da Operacao por Data do Pedido</span>
                  </div>
                </template>
                <div style="height: 300px;">
                  <canvas ref="chartEvolucao"></canvas>
                </div>
              </b-card>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="12">
              <b-card class="border-0 shadow-sm mb-4 overflow-hidden">
                <template #header>
                  <div class="d-flex align-items-center justify-content-between flex-wrap">
                    <div class="d-flex align-items-center mb-2 mb-md-0">
                      <i class="fa fa-list-alt mr-2 text-dark"></i>
                      <span class="font-weight-bold">Consolidado por Produto</span>
                    </div>
                    <div class="d-flex align-items-center">
                      <small class="text-muted mr-2">{{ produtos.length }} produtos no periodo</small>
                      <b-button
                        size="sm"
                        variant="outline-primary"
                        class="btn-card-print"
                        :disabled="loading || !produtos.length"
                        v-b-tooltip.hover
                        title="Imprimir consolidado por produto"
                        @click="imprimirProdutos"
                      >
                        <i class="fa fa-print"></i>
                      </b-button>
                    </div>
                  </div>
                </template>
                <b-table
                  :items="produtos"
                  :fields="fieldsProdutos"
                  hover
                  striped
                  responsive
                  class="mb-0"
                  head-variant="light"
                  show-empty
                  empty-text="Nenhum produto encontrado no periodo informado."
                >
                  <template #cell(pecasConsolidadas)="data">
                    {{ formatNumero(data.value) }}
                  </template>
                  <template #cell(quantEstimada)="data">
                    {{ formatPeso(data.value) }}
                  </template>
                  <template #cell(quantEfetiva)="data">
                    {{ formatPeso(data.value) }}
                  </template>
                  <template #cell(quantConsolidada)="data">
                    <strong>{{ formatPeso(data.value) }}</strong>
                  </template>
                  <template #cell(receitaConsolidada)="data">
                    <strong class="text-primary">{{ formatBRL(data.value) }}</strong>
                  </template>
                  <template #cell(lucroConsolidado)="data">
                    <strong class="text-success">{{ formatBRL(data.value) }}</strong>
                  </template>
                  <template #cell(percentualLucro)="data">
                    <strong class="text-success">{{ formatPercentual(data.value) }}</strong>
                  </template>
                  <template #cell(participacaoQuant)="data">
                    <b-progress :value="data.value" max="100" show-value variant="info" style="height: 12px;" />
                  </template>
                  <template #custom-foot>
                    <b-tr variant="light">
                      <b-th colspan="2" class="text-right">Totais</b-th>
                      <b-th class="text-center">{{ formatNumero(totalProdutos('pedidos')) }}</b-th>
                      <b-th class="text-right">{{ formatNumero(totalProdutos('pecasConsolidadas')) }}</b-th>
                      <b-th class="text-right">{{ formatPeso(totalProdutos('quantEstimada')) }}</b-th>
                      <b-th class="text-right">{{ formatPeso(totalProdutos('quantEfetiva')) }}</b-th>
                      <b-th class="text-right">{{ formatPeso(totalProdutos('quantConsolidada')) }}</b-th>
                      <b-th class="text-right text-primary">{{ formatBRL(totalProdutos('receitaConsolidada')) }}</b-th>
                      <b-th class="text-right text-success">{{ formatBRL(totalProdutos('lucroConsolidado')) }}</b-th>
                      <b-th class="text-right text-success">{{ formatPercentual(resumo.percentualLucro) }}</b-th>
                      <b-th class="text-center">100,00%</b-th>
                    </b-tr>
                  </template>
                </b-table>
              </b-card>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="12">
              <b-card class="border-0 shadow-sm overflow-hidden">
                <template #header>
                  <div class="d-flex align-items-center justify-content-between flex-wrap">
                    <div class="d-flex align-items-center mb-2 mb-md-0">
                      <i class="fa fa-truck mr-2 text-warning"></i>
                      <span class="font-weight-bold">Pedidos da Operacao</span>
                    </div>
                    <div class="d-flex align-items-center">
                      <small class="text-muted mr-2">{{ pedidos.length }} pedidos no periodo</small>
                      <b-button
                        size="sm"
                        variant="outline-primary"
                        class="btn-card-print"
                        :disabled="loading || !pedidos.length"
                        v-b-tooltip.hover
                        title="Imprimir pedidos da operacao"
                        @click="imprimirPedidos"
                      >
                        <i class="fa fa-print"></i>
                      </b-button>
                    </div>
                  </div>
                </template>
                <b-table
                  :items="pedidos"
                  :fields="fieldsPedidos"
                  hover
                  small
                  responsive
                  class="mb-0"
                  head-variant="light"
                  show-empty
                  empty-text="Nenhum pedido encontrado no periodo informado."
                >
                  <template #cell(dtPedido)="data">
                    {{ formatDataBR(data.value) }}
                  </template>
                  <template #cell(dtSaida)="data">
                    {{ formatDataBR(data.value) }}
                  </template>
                  <template #cell(situacaoDescricao)="data">
                    <b-badge :variant="variantSituacao(data.item.situacao)">{{ data.value }}</b-badge>
                  </template>
                  <template #cell(pecasConsolidadas)="data">
                    {{ formatNumero(data.value) }}
                  </template>
                  <template #cell(quantConsolidada)="data">
                    <strong>{{ formatPeso(data.value) }}</strong>
                  </template>
                  <template #cell(receitaConsolidada)="data">
                    <strong class="text-primary">{{ formatBRL(data.value) }}</strong>
                  </template>
                  <template #cell(lucroConsolidado)="data">
                    <strong class="text-success">{{ formatBRL(data.value) }}</strong>
                  </template>
                  <template #cell(percentualLucro)="data">
                    <strong class="text-success">{{ formatPercentual(data.value) }}</strong>
                  </template>
                  <template #custom-foot>
                    <b-tr variant="light">
                      <b-th colspan="6" class="text-right">Totais</b-th>
                      <b-th class="text-right">{{ formatNumero(totalPedidos('pecasConsolidadas')) }}</b-th>
                      <b-th class="text-right">{{ formatPeso(totalPedidos('quantConsolidada')) }}</b-th>
                      <b-th class="text-right text-primary">{{ formatBRL(totalPedidos('receitaConsolidada')) }}</b-th>
                      <b-th class="text-right text-success">{{ formatBRL(totalPedidos('lucroConsolidado')) }}</b-th>
                      <b-th class="text-right text-success">{{ formatPercentual(resumo.percentualLucro) }}</b-th>
                    </b-tr>
                  </template>
                </b-table>
              </b-card>
            </b-col>
          </b-row>
        </div>
      </b-overlay>
    </div>

    <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-between align-items-center">
      <div class="text-muted small pl-3">
        <i class="fa fa-info-circle mr-1"></i> A estimativa usa a quantidade prevista gravada no pedido/itens.
      </div>
      <div>
        <b-button variant="soft-danger" pill class="px-4 font-weight-bold mr-2" @click="fechar">
          FECHAR
        </b-button>
        <b-button variant="success" pill class="px-5 font-weight-bold shadow-sm" @click="carregarDados" :disabled="loading">
          <i class="fa fa-refresh mr-1"></i> RECARREGAR
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Chart from 'chart.js'
import moment from 'moment'
import CecInputData from '@/components/Cec/CecInputData.vue'
import { printGroupedHtmlReport } from '@/utils/RelatorioHTML'

function isoDateWithOffset(days) {
  const date = new Date()
  date.setDate(date.getDate() + days)
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

export default {
  name: 'OperacaoVendaDashboardModal',
  components: {
    CecInputData
  },
  props: {
    id: {
      type: String,
      default: 'modal-operacao-vendas-dashboard'
    }
  },
  data() {
    return {
      loading: false,
      carregadoUmaVez: false,
      filtros: {
        dt1: isoDateWithOffset(0),
        dt2: isoDateWithOffset(7)
      },
      dashboard: {
        resumo: {
          pedidosPeriodo: 0,
          produtosDistintos: 0,
          pecasEstimadas: 0,
          pecasEfetivas: 0,
          pecasConsolidadas: 0,
          quantEstimada: 0,
          quantEfetiva: 0,
          quantConsolidada: 0,
          receitaConsolidada: 0,
          custoConsolidado: 0,
          lucroEstimado: 0,
          lucroEfetivo: 0,
          lucroConsolidado: 0,
          percentualLucro: 0
        },
        produtos: [],
        pedidos: [],
        evolucao: []
      },
      charts: {
        produtosQuantidade: null,
        produtosLucro: null,
        evolucao: null
      },
      fieldsProdutos: [
        { key: 'produto', label: 'Produto', sortable: true },
        { key: 'grupo', label: 'Grupo', sortable: true },
        { key: 'pedidos', label: 'Pedidos', class: 'text-center' },
        { key: 'pecasConsolidadas', label: 'Volumes', class: 'text-right' },
        { key: 'quantEstimada', label: 'Quant. Estimada', class: 'text-right' },
        { key: 'quantEfetiva', label: 'Quant. Efetiva', class: 'text-right' },
        { key: 'quantConsolidada', label: 'Quant. Consolidada', class: 'text-right' },
        { key: 'receitaConsolidada', label: 'Total Consolidado', class: 'text-right' },
        { key: 'lucroConsolidado', label: 'Lucro Consolidado', class: 'text-right' },
        { key: 'percentualLucro', label: '% Lucro', class: 'text-right', thStyle: { width: '110px' } },
        { key: 'participacaoQuant', label: '% Quant.', class: 'text-center', thStyle: { width: '150px' } }
      ],
      fieldsPedidos: [
        { key: 'pedidoId', label: 'Pedido', sortable: true },
        { key: 'dtPedido', label: 'Dt. Pedido', sortable: true },
        { key: 'dtSaida', label: 'Dt. Venda', sortable: true },
        { key: 'nomeCliente', label: 'Cliente', sortable: true },
        { key: 'nomeVendedor', label: 'Vendedor', sortable: true },
        { key: 'situacaoDescricao', label: 'Situacao', sortable: true },
        { key: 'pecasConsolidadas', label: 'Volumes', class: 'text-right' },
        { key: 'quantConsolidada', label: 'Quant. Consolidada', class: 'text-right' },
        { key: 'receitaConsolidada', label: 'Total Consolidado', class: 'text-right' },
        { key: 'lucroConsolidado', label: 'Lucro Consolidado', class: 'text-right' },
        { key: 'percentualLucro', label: '% Lucro', class: 'text-right', thStyle: { width: '110px' } }
      ]
    }
  },
  computed: {
    resumo() {
      return this.dashboard.resumo || {}
    },
    produtos() {
      return this.dashboard.produtos || []
    },
    pedidos() {
      return this.dashboard.pedidos || []
    },
    evolucao() {
      return this.dashboard.evolucao || []
    }
  },
  methods: {
    fechar() {
      this.$bvModal.hide(this.id)
    },
    async onShown() {
      if (!this.carregadoUmaVez) {
        await this.carregarDados()
        this.carregadoUmaVez = true
      } else {
        this.$nextTick(() => this.renderCharts())
      }
    },
    async carregarDados() {
      if (!this.filtros.dt1 || !this.filtros.dt2) return

      this.loading = true
      try {
        const { data } = await this.$http.get('/api/protected/venda/operacao-dashboard', {
          params: {
            dt1: this.filtros.dt1,
            dt2: this.filtros.dt2
          }
        })

        this.dashboard = data || this.dashboard
        this.$nextTick(() => this.renderCharts())
      } catch (err) {
        this.$bvToast.toast('Nao foi possivel carregar o dashboard operacional de vendas.', {
          variant: 'danger',
          solid: true
        })
      } finally {
        this.loading = false
      }
    },
    destroyCharts() {
      Object.keys(this.charts).forEach((key) => {
        if (this.charts[key]) {
          this.charts[key].destroy()
          this.charts[key] = null
        }
      })
    },
    renderCharts() {
      this.destroyCharts()
      this.renderChartProdutosQuantidade()
      this.renderChartProdutosLucro()
      this.renderChartEvolucao()
    },
    drawValueLabels(chart, formatter, options = {}) {
      const context = chart.ctx
      const horizontal = options.horizontal === true
      const datasetIndexes = options.datasetIndexes || chart.data.datasets.map((_, index) => index)

      context.save()
      context.font = '700 10px Arial'
      context.fillStyle = options.color || '#334155'
      context.textBaseline = 'middle'

      datasetIndexes.forEach((datasetIndex) => {
        const meta = chart.getDatasetMeta(datasetIndex)
        const dataset = chart.data.datasets[datasetIndex]

        if (!meta || meta.hidden || !dataset) return

        meta.data.forEach((element, index) => {
          const rawValue = dataset.data[index]
          if (rawValue == null) return

          const position = element._model || {}
          const label = formatter(rawValue, datasetIndex, index)

          if (horizontal) {
            context.textAlign = 'left'
            context.fillText(label, position.x + 8, position.y)
            return
          }

          context.textAlign = 'center'
          context.fillText(label, position.x, position.y - 10)
        })
      })

      context.restore()
    },
    renderChartProdutosQuantidade() {
      if (!this.$refs.chartProdutosQuantidade) return
      const itens = this.produtos.slice(0, 10)
      const ctx = this.$refs.chartProdutosQuantidade.getContext('2d')
      const vm = this
      this.charts.produtosQuantidade = new Chart(ctx, {
        type: 'horizontalBar',
        data: {
          labels: itens.map(item => item.produto),
          datasets: [{
            label: 'Quantidade Consolidada',
            data: itens.map(item => item.quantConsolidada),
            backgroundColor: 'rgba(32, 168, 216, 0.25)',
            borderColor: '#20a8d8',
            borderWidth: 1
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: { display: false },
          animation: {
            duration: 1,
            onComplete() {
              vm.drawValueLabels(this.chart, value => vm.formatPeso(value), { horizontal: true, color: '#0f172a' })
            }
          },
          scales: {
            xAxes: [{
              ticks: {
                beginAtZero: true,
                callback: value => this.formatPeso(value)
              }
            }],
            yAxes: [{
              ticks: {
                fontSize: 10
              }
            }]
          }
        }
      })
    },
    renderChartProdutosLucro() {
      if (!this.$refs.chartProdutosLucro) return
      const itens = [...this.produtos]
        .sort((a, b) => b.percentualLucro - a.percentualLucro)
        .slice(0, 10)
      const ctx = this.$refs.chartProdutosLucro.getContext('2d')
      const vm = this
      this.charts.produtosLucro = new Chart(ctx, {
        type: 'horizontalBar',
        data: {
          labels: itens.map(item => item.produto),
          datasets: [{
            label: '% de Lucro',
            data: itens.map(item => item.percentualLucro || 0),
            backgroundColor: 'rgba(77, 189, 116, 0.25)',
            borderColor: '#4dbd74',
            borderWidth: 1
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: { display: false },
          animation: {
            duration: 1,
            onComplete() {
              vm.drawValueLabels(this.chart, (value, datasetIndex, itemIndex) => {
                const produto = itens[itemIndex] || {}
                return `${vm.formatPercentual(value)} | ${vm.formatBRL(produto.lucroConsolidado)}`
              }, { horizontal: true, color: '#166534' })
            }
          },
          scales: {
            xAxes: [{
              ticks: {
                beginAtZero: true,
                max: 100,
                callback: value => this.formatPercentual(value)
              }
            }],
            yAxes: [{
              ticks: {
                fontSize: 10,
                mirror: false
              }
            }]
          }
        }
      })
    },
    renderChartEvolucao() {
      if (!this.$refs.chartEvolucao) return
      const ctx = this.$refs.chartEvolucao.getContext('2d')
      const vm = this
      this.charts.evolucao = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: this.evolucao.map(item => this.formatDataBR(item.data)),
          datasets: [
            {
              label: 'Quant. Estimada',
              data: this.evolucao.map(item => item.quantEstimada),
              backgroundColor: 'rgba(255, 193, 7, 0.35)',
              borderColor: '#ffc107',
              borderWidth: 1
            },
            {
              label: 'Quant. Efetiva',
              data: this.evolucao.map(item => item.quantEfetiva),
              backgroundColor: 'rgba(77, 189, 116, 0.35)',
              borderColor: '#4dbd74',
              borderWidth: 1
            },
            {
              label: 'Lucro Consolidado',
              data: this.evolucao.map(item => item.lucroConsolidado),
              type: 'line',
              borderColor: '#0f766e',
              backgroundColor: 'transparent',
              yAxisID: 'y-lucro',
              pointBackgroundColor: '#0f766e',
              tension: 0.35
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          animation: {
            duration: 1,
            onComplete() {
              vm.drawValueLabels(this.chart, (value, datasetIndex) => {
                return datasetIndex === 2 ? vm.formatBRL(value) : vm.formatPeso(value)
              }, {
                datasetIndexes: [0, 1, 2],
                color: '#334155'
              })
            }
          },
          scales: {
            yAxes: [
              {
                id: 'y-quantidade',
                position: 'left',
                ticks: {
                  beginAtZero: true,
                  callback: value => this.formatPeso(value)
                }
              },
              {
                id: 'y-lucro',
                position: 'right',
                gridLines: { drawOnChartArea: false },
                ticks: {
                  beginAtZero: true,
                  callback: value => this.formatBRL(value)
                }
              }
            ]
          }
        }
      })
    },
    formatDataBR(value) {
      if (!value) return '-'
      return moment(value).format('DD/MM/YYYY')
    },
    formatNumero(value) {
      return Number(value || 0).toLocaleString('pt-BR', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      })
    },
    formatPeso(value) {
      return Number(value || 0).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    },
    formatBRL(value) {
      return Number(value || 0).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      })
    },
    formatMoedaRelatorio(value) {
      return Number(value || 0).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    },
    formatPercentual(value) {
      return `${Number(value || 0).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })}%`
    },
    totalProdutos(field) {
      return this.produtos.reduce((total, item) => total + Number(item[field] || 0), 0)
    },
    totalPedidos(field) {
      return this.pedidos.reduce((total, item) => total + Number(item[field] || 0), 0)
    },
    getObservacoesRelatorio() {
      return [
        `Periodo: ${this.formatDataBR(this.filtros.dt1)} ate ${this.formatDataBR(this.filtros.dt2)}`,
        'Base: Pedidos por Data do Pedido',
        'Leitura: valores consolidados entre estimado e efetivo conforme situacao do pedido'
      ].join('\n')
    },
    getPercentualLucroLinhas(rows) {
      const receita = rows.reduce((total, item) => total + Number(item.receitaConsolidada || 0), 0)
      const lucro = rows.reduce((total, item) => total + Number(item.lucroConsolidado || 0), 0)
      return receita > 0 ? (lucro / receita) * 100 : 0
    },
    getColunasRelatorioProdutos() {
      return [
        { key: 'produtoId', label: 'Cod.', width: '6%', align: 'right' },
        { key: 'produto', label: 'Produto', width: '25%' },
        { key: 'grupo', label: 'Grupo', width: '16%' },
        { key: 'pedidos', label: 'Pedidos', width: '7%', align: 'right' },
        { key: 'pecasConsolidadas', label: 'Volumes', width: '8%', align: 'right', formatter: value => this.formatNumero(value) },
        { key: 'quantEstimada', label: 'Qtd. Est.', width: '8%', align: 'right', formatter: value => this.formatPeso(value) },
        { key: 'quantEfetiva', label: 'Qtd. Efet.', width: '8%', align: 'right', formatter: value => this.formatPeso(value) },
        { key: 'quantConsolidada', label: 'Qtd. Cons.', width: '8%', align: 'right', formatter: value => this.formatPeso(value) },
        { key: 'receitaConsolidada', label: 'Total (R$)', width: '8%', align: 'right', formatter: value => this.formatMoedaRelatorio(value) },
        { key: 'lucroConsolidado', label: 'Lucro (R$)', width: '8%', align: 'right', formatter: value => this.formatMoedaRelatorio(value) },
        {
          key: 'percentualLucro',
          label: '% Lucro',
          width: '6%',
          align: 'right',
          formatter: value => this.formatPercentual(value),
          summary: rows => this.getPercentualLucroLinhas(rows)
        }
      ]
    },
    getColunasRelatorioPedidos() {
      return [
        { key: 'pedidoId', label: 'Pedido', width: '6%', align: 'right' },
        { key: 'dtPedido', label: 'Dt. Pedido', width: '8%', align: 'center', formatter: value => this.formatDataBR(value) },
        { key: 'dtSaida', label: 'Dt. Venda', width: '8%', align: 'center', formatter: value => this.formatDataBR(value) },
        { key: 'nomeCliente', label: 'Cliente', width: '22%' },
        { key: 'nomeVendedor', label: 'Vendedor', width: '18%' },
        { key: 'situacaoDescricao', label: 'Situacao', width: '12%' },
        { key: 'pecasConsolidadas', label: 'Volumes', width: '7%', align: 'right', formatter: value => this.formatNumero(value) },
        { key: 'quantConsolidada', label: 'Qtd. Cons.', width: '8%', align: 'right', formatter: value => this.formatPeso(value) },
        { key: 'receitaConsolidada', label: 'Total (R$)', width: '8%', align: 'right', formatter: value => this.formatMoedaRelatorio(value) },
        { key: 'lucroConsolidado', label: 'Lucro (R$)', width: '8%', align: 'right', formatter: value => this.formatMoedaRelatorio(value) },
        {
          key: 'percentualLucro',
          label: '% Lucro',
          width: '6%',
          align: 'right',
          formatter: value => this.formatPercentual(value),
          summary: rows => this.getPercentualLucroLinhas(rows)
        }
      ]
    },
    imprimirProdutos() {
      if (!this.produtos.length) {
        this.$bvToast.toast('Nenhum produto encontrado para imprimir.', {
          variant: 'warning',
          solid: true
        })
        return
      }

      printGroupedHtmlReport({
        rows: this.produtos,
        columns: this.getColunasRelatorioProdutos(),
        groupBy: { key: null, getKey: () => 'GERAL', getLabel: () => 'Consolidado por Produto' },
        sumKeys: ['pedidos', 'pecasConsolidadas', 'quantEstimada', 'quantEfetiva', 'quantConsolidada', 'receitaConsolidada', 'lucroConsolidado', 'percentualLucro'],
        reportTitle: 'Dashboard Operacional de Vendas - Consolidado por Produto',
        printedBy: window.localStorage.getItem('login') || '',
        observations: this.getObservacoesRelatorio(),
        landscape: true
      })
    },
    imprimirPedidos() {
      if (!this.pedidos.length) {
        this.$bvToast.toast('Nenhum pedido encontrado para imprimir.', {
          variant: 'warning',
          solid: true
        })
        return
      }

      printGroupedHtmlReport({
        rows: this.pedidos,
        columns: this.getColunasRelatorioPedidos(),
        groupBy: { key: 'dtPedido', formatter: value => `Data do Pedido: ${this.formatDataBR(value)}` },
        sumKeys: ['pecasConsolidadas', 'quantConsolidada', 'receitaConsolidada', 'lucroConsolidado', 'percentualLucro'],
        reportTitle: 'Dashboard Operacional de Vendas - Pedidos da Operacao',
        printedBy: window.localStorage.getItem('login') || '',
        observations: this.getObservacoesRelatorio(),
        landscape: true
      })
    },
    variantSituacao(situacao) {
      if (['2', '3', '4'].includes(String(situacao || ''))) return 'warning'
      if (['1', '6'].includes(String(situacao || ''))) return 'success'
      if (['7', '8'].includes(String(situacao || ''))) return 'info'
      return 'secondary'
    }
  },
  beforeDestroy() {
    this.destroyCharts()
  }
}
</script>

<style scoped>
.modal-header-premium {
  border-bottom: none;
}

.header-icon-wrapper {
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  font-size: 1.5rem;
}

.bg-white-10 {
  background-color: rgba(255, 255, 255, 0.15) !important;
}

.modal-section-title {
  font-size: 0.9rem;
  font-weight: 700;
  color: #2d3748;
  border-bottom: 2px solid #edf2f7;
  padding-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.modal-label-premium {
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #6c757d;
  margin-bottom: 0.4rem;
  display: block;
}

.modal-footer-premium {
  gap: 1rem;
}

.shadow-xs {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05) !important;
}

.report-container {
  background-color: #f8fafc;
}

.kpi-card-premium {
  background: #fff;
  padding: 1rem 1.1rem;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.kpi-card-premium small {
  display: block;
  text-transform: uppercase;
  font-weight: 700;
  color: #94a3b8;
  font-size: 0.68rem;
  margin-bottom: 0.45rem;
}

.kpi-card-premium h4 {
  font-weight: 800;
  letter-spacing: -0.4px;
}

.border-left-warning { border-left: 4px solid #ffc107; }
.border-left-info { border-left: 4px solid #20a8d8; }
.border-left-primary { border-left: 4px solid #007bff; }
.border-left-success { border-left: 4px solid #4dbd74; }
.border-left-dark { border-left: 4px solid #2f353a; }
.border-left-teal { border-left: 4px solid #0f766e; }
.text-teal { color: #0f766e; }

.btn-soft-danger,
.btn-soft-danger:hover,
.btn-soft-danger:focus {
  border: none;
}

.btn-soft-danger {
  background-color: rgba(248, 108, 107, 0.1);
  color: #f86c6b;
}

.btn-soft-danger:hover {
  background-color: #f86c6b;
  color: white;
}

.text-white-50 {
  color: rgba(255, 255, 255, 0.75);
}

@media (min-width: 768px) {
  .border-left-md {
    border-left: 1px solid #dee2e6;
  }
}

@media (max-width: 767.98px) {
  .modal-footer-premium {
    flex-direction: column;
    align-items: stretch !important;
  }
}

@media print {
  .modal-footer-premium,
  .btn,
  .modal-header-premium button {
    display: none !important;
  }
}
</style>

<style>
.modal-dialog.modal-xl-custom {
  width: calc(100vw - 2rem);
  max-width: 1560px;
  margin: 1rem auto;
}

.modal-dialog.modal-xl-custom .modal-content {
  border-radius: 18px;
}

@media (max-width: 767.98px) {
  .modal-dialog.modal-xl-custom {
    width: calc(100vw - 1rem);
    max-width: calc(100vw - 1rem);
    margin: 0.5rem auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/OperacaoVendaDashboardModal.vue